import { WithOverride } from '@udecode/plate';
import { BaseRange, Editor } from 'slate';
import { ReactEditor } from 'slate-react';

import { SlatePluginsStore } from '../store';
import { MicroTaskPlugin } from './createMicroTaskPlugin';

const ELEMENT_MICRO_TASK = 'micro_task';

export type onRemoveMicroTask = SlatePluginsStore['removeTask'];

export const withMicroTask: WithOverride<Record<string, unknown> & MicroTaskPlugin> = (
  editor,
  { options: { onRemoveMicroTask } }
) => {
  const { apply } = editor;
  editor.apply = (op: any) => {
    // move this into a separate plugin
    // if (YjsEditor.isRemote(editor as any)) {
    //   HistoryEditor.withoutSaving(editor as any, () => {
    //     apply(op);
    //   });
    //   return;
    // }
    if (op.type === 'insert_node' && op.path?.length === 1) {
      let range: BaseRange | undefined = undefined;
      if (editor.children?.[op?.path?.[0]]) {
        range = Editor.range(editor, op?.path);
      } else if (editor.children?.[op?.path?.[0] - 1]) {
        range = Editor.range(editor, [op?.path?.[0] - 1]);
      }

      if (range) {
        const editorWrapper = window.document.getElementById('document-wrapper');
        //TODO: fix this-> ignoring the error if the dom range not found on the DOM
        try {
          const rect = ReactEditor.toDOMRange(editor as any, range).getBoundingClientRect();
          if (rect.top + 60 > window.innerHeight) {
            editorWrapper?.scrollTo({
              top: rect.top / 4 + editorWrapper?.scrollTop,
              left: rect.left,
              behavior: 'smooth',
            });
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      }
    }
    if (op.type === 'set_node' && op.properties.type === ELEMENT_MICRO_TASK) {
      // Node to be deleted
      if (editor.children[op?.path?.[0]].id) {
        onRemoveMicroTask?.({ taskId: editor.children[op?.path?.[0]].id as string });
      }
    }

    if (op.type === 'remove_node' && op.node.type === ELEMENT_MICRO_TASK) {
      const node = op.node;
      if (node?.id) {
        onRemoveMicroTask?.({ taskId: node.id });
      }
    }
    apply(op);
  };

  return editor;
};
